export const TOOL_TASK = 'assign-users-entitlements';
export const TOOL_TITLE = 'Assign Entitlements To Users';
export const TOOL_PROGRESS_LABEL = 'Progress of assigning entitlements to users...';
export const FILE_NAME = 'Assign-entitlements-to-users-report';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once assigning entitlements to users finishes';
export const FILE_HEADERS = {
    userId: 'User Id',
    email: 'Email',
    role: 'Role',
    resources: 'Resources',
    grantName: 'Grant Name',
    actionStatus: 'Action Status',
};
